/* eslint-disable @typescript-eslint/no-unused-vars, check-file/filename-blocklist -- pre-existing in this legacy file; the dark-mode sweep only themes its colour literals */
import { Button, Flex, Icon, Link } from '@chakra-ui/react';
import React from 'react';
import { KText } from '@/ui-library/components/text';

const variants = {
  primary: {
    color: 'white',
    iconColor: '255, 255, 255',
    bgColor: 'ats-negative',
  },
  secondary: {
    color: 'var(--kula-dark-secondary-900, #454647)',
    iconColor: '242, 153, 74',
    bgColor: 'rgb(255 242 204 / var(--kula-dark-pastel-alpha, 1))',
  },
  normal: {
    color: 'var(--kula-dark-secondary-900, #454647)',
    iconColor: '0,0,0',
    bgColor: 'ats-negative',
  },
};

export const InlineNudges = ({ config = {} }) => {
  const { title, subTitle, variant = 'primary', icon, cta = {} } = config;
  const { color, iconColor, bgColor } = variants[variant];
  const {
    label,
    linkProps = {},
    Wrapper,
    wrapperProps,

    // icon: ctaIcon,
    // color: ctaColor,
    bgColor: ctaBgColor,
  } = cta;

  const renderCta = () => {
    if (Wrapper)
      return (
        <Wrapper {...wrapperProps}>
          <Button
            fontSize="12px"
            fontWeight="semiBold"
            type="submit"
            textDecoration="underline"
            leftIcon={icon}
            background="transparent"
            p="0px !important"
            _hover={{
              background: 'transparent',
            }}
          >
            {label}
          </Button>
        </Wrapper>
      );

    return (
      <Link
        fontSize="12px"
        fontWeight="semiBold"
        color={variant === 'secondary' ? ctaBgColor : 'white'}
        textDecoration="underline"
        mt="2px"
        {...linkProps}
      >
        {label}
      </Link>
    );
  };

  return (
    <Flex
      gap="7px"
      alignItems="center"
      // The secondary bar already paints this see-through yellow; painting it
      // again here stacked the two (10% each in dark mode) into a patch
      // behind the text.
      bgColor={variant === 'secondary' ? undefined : bgColor}
    >
      {icon && (
        <Icon
          w="0.75em"
          h="0.75em"
          color={iconColor}
          as={icon}
          style={{ transform: 'rotate(90deg)' }}
        />
      )}
      <KText size="sm-semi-bold" color={color} isTruncated enableTooltip={true}>
        {title}
      </KText>
      <KText size="sm-medium" color={color} isTruncated enableTooltip={true}>
        {subTitle}
      </KText>
      {label && renderCta()}
    </Flex>
  );
};
